import { Button } from "components/ui/button";
import React from "react";

interface Organization {
  orgId: string;
  orgName: string;
  orgMetadata?: Record<string, unknown>;
}

interface OrganizationSelectionModalProps {
  organizations: Organization[];
}

export const OrganizationSelectionModal: React.FC<OrganizationSelectionModalProps> = ({
  organizations,
}) => {
  const handleSelectOrganization = (org: Organization) => {
    localStorage.setItem("tz_current_org_id", org.orgId);
    localStorage.removeItem("tz_auto_selected_org_id");
    
    // Clear team selection when switching organizations
    // Since we don't have user ID at this point, we need to clear all team selection entries
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith("tz-team:")) {
        localStorage.removeItem(key);
      }
    });
    
    window.location.reload();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-card rounded-lg p-6 max-w-md w-full mx-4 border border-border">
        <h2 className="text-xl font-semibold text-foreground mb-4">
          Select Organization
        </h2>
        <p className="text-muted-foreground mb-6">
          You have access to multiple organizations. Please select one to continue.
        </p>
        <div className="space-y-3">
          {organizations.map((org) => (
            <div
              key={org.orgId}
              className="border border-border rounded-lg p-4 hover:border-primary/50 hover:bg-muted transition-colors cursor-pointer"
              onClick={() => handleSelectOrganization(org)}
            >
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-medium text-foreground">{org.orgName}</h3>
                  <p className="text-sm text-muted-foreground">ID: {org.orgId}</p>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSelectOrganization(org);
                  }}
                >
                  Select
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
